import React, {Component} from 'react';
import {Button, Input, Form, Icon, Modal, List} from "semantic-ui-react";
import {saveRoomTemplate} from "../../../../data/report_api";
import ViewClerkRoomTemplateDetail from "./room_template_detail";

class ClerkRoomTemplate extends Component {

    constructor(props) {
        super(props);
        this.state = {
            active: null,
            roomObject: [{}],
            templateName: undefined
        }
    }


    componentWillMount() {
        let roomObject = this.props.roomObject;
        if (roomObject) {
            const noOfGroups = roomObject['groups'].length;
            let groupArray = [];
            for (let i = 0; i < noOfGroups; i++) {
                let groupName = roomObject['groups'][i]['name'];
                let groupObject = {
                    name: groupName,
                    items: []
                };
                let noOfItems = roomObject['groups'][i]['items'].length;
                let itemArray = [];
                for (let j = 0; j < noOfItems; j++) {
                    const itemObj = {"name":roomObject['groups'][i]['items'][j]['name']};
                    itemArray.push(itemObj);
                }
                groupObject['items'] = itemArray;
                groupArray.push(groupObject);
            }
            let room = [{
                name: roomObject.name,
                groups: groupArray
            }];
            this.setState({roomObject: room,templateName:roomObject.name});
        }
    }

    handleSubmit = () => {
      const formData = new FormData();
      formData.append("name",this.state.templateName);
      formData.append("content",JSON.stringify(this.state.roomObject));
        saveRoomTemplate(formData).then((response)=>{
            if(response.success){
                this.props.showSaveAsTemplate(false,undefined);
            }
        })
    };

    render() {
        return (
            <Modal size="small" open={true} onClose={(e) => {
                this.props.showSaveAsTemplate(false, undefined);
            }}>
                <Modal.Header>Save as Template</Modal.Header>
                <Modal.Content scrolling>
                    <div className="modal-close-button">
                        <Button basic icon negative onClick={(e) => {
                            this.props.showSaveAsTemplate(false, undefined);
                        }}><Icon name="close"/></Button>
                    </div>
                    <Modal.Description>
                        <div>
                            <Form>
                                <Form.Field inline size="huge">
                                    <label>Template Name</label>
                                    <Input
                                        placeholder='First name'
                                        defaultValue={(this.state.roomObject && this.state.roomObject[0]) ?this.state.roomObject[0]['name']:"Room Template" }
                                        required
                                        onChange={(e)=>{this.setState({templateName:e.target.value})}}
                                    />
                                </Form.Field>
                            </Form>
                            {this.state.roomObject && <ViewClerkRoomTemplateDetail roomObject={this.state.roomObject}/>}
                        </div>
                        <div className="pad-top">
                            <p className="info-normal">*Note this action will always create new template even if a template of same structure already exists</p>
                        </div>
                    </Modal.Description>
                </Modal.Content>
                <Modal.Actions>
                    <Button content="Cancel" onClick={()=>{this.props.showSaveAsTemplate(false, undefined);}} />
                    <Button primary onClick={this.handleSubmit}>
                        Save Now <Icon name='chevron right' />
                    </Button>
                </Modal.Actions>
            </Modal>
        )
    }
}

export default ClerkRoomTemplate;


// WEBPACK FOOTER //
// ./src/views/report/templates/clerk/clerk_room_template.js